import { graphql, useStaticQuery } from "gatsby"
import { TNavigation } from "../types"

const mainNavigation = (): TNavigation => {

  const query = useStaticQuery(
    graphql`
      query {
        allNavigation(filter: { title: { eq: "Main Navigation" } }) {
          nodes {
            title
            json
          }
        }
      }
    `)

  return query.allNavigation.nodes[0]

}

export default mainNavigation
